/**
 * Names for place ids the location list does not hold: a school, a
 * kindergarten, a supermarket or a chain the search bar read ("p-..."
 * ids, backend services/poi_places). The bar's answer carries them
 * (api.magicSearch); a link that brings them is answered once by
 * /listings/place-names (filter-names). One store, bound to the loaded
 * names, so the bar's chips and the results row read the same labels.
 */
const remembered: Record<string, string> = {};
let bound: Record<string, string> | null = null;

/** Keep names the bar's answer carried. */
export function rememberPlaceNames(more: Record<string, string> | null | undefined): void {
  if (!more) return;
  Object.assign(remembered, more);
  if (bound) Object.assign(bound, more);
}

/** Point the store at the loaded location names, with what it holds. */
export function bindPlaceNames(loc: Record<string, string>): void {
  Object.assign(loc, remembered);
  bound = loc;
}

/** The "p-..." ids the page's own address carries. */
export function urlPlaceIds(): string[] {
  if (typeof window === "undefined") return [];
  const sp = new URLSearchParams(window.location.search);
  return [...sp.getAll("location_ids"), ...sp.getAll("exclude_location_ids")].filter((id) => id.startsWith("p-"));
}
